<template>
  <notification-banner v-if="$route.meta.auth == false"></notification-banner>
  <div
    class="top_nav"
    :class="{
      top_nav_locked: sideMenuLock && !subMenuLayout,
      top_nav_unlocked: !sideMenuLock && !subMenuLayout,
      top_sub_nav_locked: sideMenuLock && subMenuLayout,
      top_sub_nav_unlocked: !sideMenuLock && subMenuLayout,
    }"
  >
    <div class="page_title flex">
      <img
        v-if="sideMenu && !sideMenuActive"
        @click="sideMenuToggle"
        :src="require('@/assets/icons/icon-menu-hamburger.svg')"
        class="side_menu"
        alt="menu"
      />
      <img
        v-if="sideMenu && sideMenuActive"
        @click="sideMenuToggle"
        :src="require('@/assets/icons/icon-menu-close.svg')"
        class="side_menu"
        alt="close"
      />
      <h2>{{ pageTitle }}</h2>
    </div>
    <div class="right_menu_items">
      <div class="flex slot_content">
        <slot></slot>
      </div>
      <div v-if="showProfile && companyType == 'business'">
        <keep-alive>
          <profile-btn></profile-btn>
        </keep-alive>
      </div>
      <div v-if="showProfile && companyType == 'admin'">
        <keep-alive>
          <profile-btn-admin></profile-btn-admin>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileBtn from "./TheTopNavigationProfileBtn.vue";
import ProfileBtnAdmin from "./TheTopNavigationProfileBtnAdmin.vue";

export default {
  components: {
    ProfileBtn,
    ProfileBtnAdmin,
  },
  props: {
    pageTitle: {
      type: String,
      required: false,
    },
    showProfile: {
      type: Boolean,
      required: false,
      default: true,
    },
    subMenuLayout: {
      type: Boolean,
      required: false,
      default: false,
    },
    sideMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
    sideMenuActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    sideMenuToggle: {
      type: Function,
      required: false,
    },
  },
  computed: {
    ...mapGetters("userData", ["companyType", "sideMenuLock"]),
  },
};
</script>

<style>
/* Top Navigation */
.top_nav {
  height: 65px;
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  background: #fff;
  padding: 12px 25px;
  border-bottom: 1px solid var(--border-color);
}

.top_nav a {
  color: #000;
  text-decoration: none;
}

.top_nav_unlocked {
  left: 70px;
  width: calc(100% - 70px);
}

.top_nav_locked {
  left: 240px;
  width: calc(100% - 240px);
}

.top_sub_nav_unlocked {
  left: 296px;
  width: calc(100% - 296px);
}

.top_sub_nav_locked {
  left: 466px;
  width: calc(100% - 466px);
}

.router-link-active .center_menu_item {
  background: var(--dark);
}

.right_menu_items {
  position: absolute;
  display: flex;
  align-items: center;
  right: 20px;
  text-align: right;
  display: flex;
  gap: 10px;
}

.side_menu {
  height: 15px;
  cursor: pointer;
}

/* Dropdown Menu Items */

.top_nav_sub_menu {
  width: 280px;
}

.top_nav_sub_menu a {
  color: #000;
  text-decoration: none;
}

.top_nav_list_menu {
  padding: 10px 10px;
  border-radius: var(--border-radius);
  cursor: pointer;
}
.top_nav_list_menu:hover {
  background: var(--grey-light);
}

.mobile_menu {
  display: none;
}

@media only screen and (max-width: 500px) {
  .top_nav {
    height: fit-content;
    position: relative;
    flex-direction: column;
    border-bottom: 0px;
  }

  .top_nav_unlocked {
    left: 0px;
    width: 100%;
  }

  .top_nav_locked {
    left: 0px;
    width: 100%;
  }
  .top_sub_nav_unlocked {
    left: 0px;
    width: 100%;
  }

  .top_sub_nav_locked {
    left: 0px;
    width: 100%;
  }

  .page_title {
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: center;
  }

  .right_menu_items {
    position: relative;
    text-align: left;
    display: flex;
    flex-direction: column;
    width: 100%;
    right: 0px;
  }

  .slot_content {
    flex-direction: column;
    width: 100%;
  }

  .mobile_menu {
    display: flex;
    margin-right: 15px;
  }

  .profile_btn {
    display: none;
  }
}
</style>
